"use client";
import React, { useState, useEffect } from "react";
import searchIcon from "@/assets/icons/NewHomePage/searchBlu.svg";
import Image from "next/image";
import { useTranslations } from "next-intl";
import { useLanguage } from "@/contexts/LanguageContext";
import searchCartIcon from "@/assets/imgs/store/searchIcon.svg";
export default function SearchInput({
  className,
  onChange,
  placeholder,
  onFocus,
  onBlur,
  isCart = false,
  delay = 300, // default wait time in ms
}: {
  className?: string;
  onChange?: (value: string) => void;
  onFocus?: any;
  onBlur?: any;
  delay?: number;
  placeholder?: string;
  isCart?: boolean;
}) {
  const [value, setValue] = useState("");
  const { language } = useLanguage();
  const isRTL = language === "ar";

  // Debounce effect
  useEffect(() => {
    const handler = setTimeout(() => {
      if (value.trim() !== "") {
        onChange?.(value);
      }
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay, onChange]);

  const t = useTranslations();

  return (
    <div
      className={`relative w-full border border-white/20 rounded-[10px] overflow-hidden backdrop-blur-md h-[36px]  ${className || ""}`}
      style={{
        background: "rgba(255, 255, 255, 0.10)",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
      }}
    >
      <input
        type="text"
        className={`bg-transparent text-[#D1D3D4] rounded-[20px] md:rounded-[10px] py-[10px] ps-[40px] md:ps-[50px] pe-[15px] w-full h-full border-none placeholder:font-medium placeholder:text-[15px] sm:placeholder:text-[10px] lg:placeholder:text-[16px] placeholder:text-[#D1D3D4] shadow-none focus:outline-none focus:ring-0 focus:ring-none relative z-10 text-[16px] sm:text-[14px] appearance-none ltr:text-left rtl:text-right`}
        placeholder={placeholder ? placeholder : t("newHome.searchPlaceholder")}
        onChange={(e: any) => {
          setValue(e.target.value);
        }}
        onFocus={onFocus}
        onBlur={onBlur}
      />
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`w-[14px] md:w-auto absolute top-1/2 transform -translate-y-1/2 z-20 pointer-events-none ${
          isRTL ? "start-3" : "start-3"
        }`}
      >
        <path
          d="M15.553 15.553C16.2086 14.8974 16.7287 14.119 17.0835 13.2624C17.4383 12.4058 17.6209 11.4877 17.6209 10.5605C17.6209 9.63331 17.4383 8.71519 17.0835 7.85858C16.7287 7.00196 16.2086 6.22362 15.553 5.568C14.8973 4.91237 14.119 4.39231 13.2624 4.03748C12.4058 3.68266 11.4877 3.50004 10.5605 3.50004C9.63327 3.50004 8.71515 3.68266 7.85854 4.03748C7.00192 4.39231 6.22359 4.91237 5.56796 5.568C4.24387 6.89209 3.5 8.68795 3.5 10.5605C3.5 12.4331 4.24387 14.2289 5.56796 15.553C6.89205 16.8771 8.68791 17.621 10.5605 17.621C12.433 17.621 14.2289 16.8771 15.553 15.553ZM15.553 15.553L20 20"
          stroke="#D4AE38"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
